import React, { Component } from 'react';
import "./WhatsappButton.css";
import styled from "styled-components";

const Border=styled.a`
position:fixed;
bottom:40px;
right:20px;
width:55px;
height:55px;
background-color:#25d366;
color:#FFF;
border-radius:50px;
text-align:center;
font-size:30px;
z-index:2;
`;

const WhatsappButton=({show,bottom=0,number})=>
{
    const API=`https://api.whatsapp.com/send?phone=${number}`

    if(show)
    {
       return <Border href={API} style={{bottom:bottom}} className="float" target="_blank">
         <i className="fa fa-whatsapp my-float"></i>   
       </Border>
    }
    else
    {
        return ""
    }
}

export default WhatsappButton
